export default {"src":"/_next/static/media/account.d66e7628.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};